export default class Base {

    static INIT_DONE = false;

    constructor() {
        this.debug = false;
        this.superDebug = false;

        if(this.constructor.TAG) {
            this.TAG = this.constructor.TAG;
        } else {
            this.TAG = "";
        }
    }

    static initialize() {}

    enableMethodLog() {
        if (this.debug) {
            for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
                let method = this[name];
                // Supposedly you'd like to skip constructor
                if (!(method instanceof Function) || name === "constructor") continue;

                this[name] = (function (method, name, _this) {
                    return (...args) => {
                        _this.flog(name);
                        method.apply(_this, args);
                    };
                })(method, name, this);
            }
        }
    }

    flog(f) {
        this.debug ? console.debug(`${this.TAG}.${f}`) : "";
    }

    dlog(message) {
        console.debug(this.TAG, message);
    }
}


// WEBPACK FOOTER //
// /data/php7/vendor/etouches/ecore/es6/base/Base.es6